export const LOCAL_STORAGE_KEYS = {
  CURRENT_PATH: 'currentPath',
}
